const introduceTabData = [
  {
    title: "개요",
    href: "/introduction/summary",
  },
  {
    title: "인사말",
    href: "/introduction/greeting",
  },
  {
    title: "조직도",
    href: "/introduction/organization",
  },
  {
    title: "지식재산권과 창업",
    href: "/introduction/ipstartup",
  },
  {
    title: "전담특허사무소",
    href: "/introduction/patent-office",
  },
  {
    title: "특허자료 검색",
    href: "https://patent.snuh.org/",
    target: "_blank",
  },
  {
    title: "찾아오시는 길",
    href: "/introduction/map",
  },
];

const programData = [
  {
    title: "프로그램 신청",
    href: "/program/list",
  },
  {
    title: "1대1 특허상담프로그램(S.T.A.R.T.) 신청",
    href: "/counsel/schedule",
  },
];

const technicalIntroData = [
  {
    title: "Startup",
    href: "/platform/startup",
  },
  {
    title: "Patent",
    href: "/platform/patent",
  },
];

const startupCompanyData = [
  {
    title: "병원 창업기업",
    href: "/hospital/startup",
  },
  {
    title: "SNUH 벤처",
    href: "https://www.snuhventure.com",
    target: "_blank",
  },
];

const communityData = [
  {
    title: "공지사항",
    href: "/community/notice",
  },
  {
    title: "일정",
    href: "/community/schedule",
  },
  {
    title: "자료실",
    href: "/community/archive",
  },
  {
    title: "1대1 문의",
    href: "/community/inquiry",
    requireLogin: true,
  },
];

const mypageData = [
  {
    title: "내 정보",
    href: "/mypage/info",
  },
  {
    title: "내 교육",
    href: "/mypage/education",
  },
  {
    title: "내 문의",
    href: "/mypage/inquiry",
  },
];

export {
  introduceTabData,
  programData,
  technicalIntroData,
  startupCompanyData,
  communityData,
  mypageData,
};
